import React from "react";
import { BrowserRouter } from "react-router-dom";
import UserContext from "src/contexts/userContext";

import SSO from "src/pages/sso";
import Router from "src/router";
import ChunkErrorBoundary from "src/components/ChunkErrorBoundary";
import ActAsBanner from "src/components/ActAsBanner";

const App = () => {
  /* ⚠ ХАСАГДСАН (2026-10-14): `/assessments/:id` гэсэн НЭВТРЭЛТГҮЙ зам
     нь легаси `workservice/assessment` хуудсыг `UserContext`-ээс
     ГАДУУР ачаалж, `https://hse-risk.erdenetmc.mn/api/...` гэсэн
     ГАДНЫ сервер рүү хандаж байв.
     ЯАГААД ХАСАВ (баримт, 2026-10-14):
       • тэр хост 503 буцаана — үйлчилгээ унасан, хуудас ажиллах
         боломжгүй;
       • легаси `risk.Assessments` нь 23 мөр, бүгд 2023-07 … 2024-02 —
         2024-02-20-наас хойш нэг ч бичлэг алга;
       • QR нь `hse.erdenetmc.mn/assessments/<id>` гэж хэвлэгддэг байсан
         ч тэр наалт өнөөдөр ч ажиллахгүй (дээрх 503).
     Хэрэглэгчийн шийдвэр: «хэрэглээгүй бол хаая». */
  // ⚠ ГАДНА ТАЛЫН ХАМГААЛАЛТ — router.js дотор бас нэг байгаа нь давхардал
  // биш: энэ нь UserContext (нэвтрэлт, эрх татах) болон SSO-гийн алдааг ч
  // барина. Ямар ч алдаанд хэрэглэгч ЦАГААН ХУУДАС биш, мэдэгдэл харна.
  return (
    <ChunkErrorBoundary>
      {/* ⚠ ХАМГИЙН ГАДНА — UserContext, Router, эрхийн шалгалтаас
          ГАДУУР. Эрх багатай дүрд орж цэс хоосорсон, API 403 болсон ч
          тууз үлдэж, буцах зам нээлттэй байх ЁСТОЙ. */}
      <ActAsBanner />
      <BrowserRouter>
        {window.location.pathname === "/callback" ? (
          <SSO />
        ) : (
          <UserContext>
            <Router />
          </UserContext>
        )}
      </BrowserRouter>
    </ChunkErrorBoundary>
  );
};

export default React.memo(App);
